import React from 'react';
import {
  BookOutlined,
  PlusCircleOutlined,
  SettingOutlined,
  AlertOutlined,
  EyeOutlined,
  DesktopOutlined,
  QuestionCircleOutlined,
  FileTextOutlined,
  RocketOutlined,
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  BarChartOutlined,
  UserOutlined,
  TeamOutlined,
  GlobalOutlined,
  CloudOutlined,
  TagOutlined,
  ThunderboltOutlined,
  ToolOutlined,
  BulbOutlined,
  SafetyOutlined,
  FundOutlined,
} from '@ant-design/icons';

const iconMap = {
  BookOutlined,
  PlusCircleOutlined,
  SettingOutlined,
  AlertOutlined,
  EyeOutlined,
  DesktopOutlined,
  QuestionCircleOutlined,
  FileTextOutlined,
  RocketOutlined,
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  BarChartOutlined,
  UserOutlined,
  TeamOutlined,
  GlobalOutlined,
  CloudOutlined,
  TagOutlined,
  ThunderboltOutlined,
  ToolOutlined,
  BulbOutlined,
  SafetyOutlined,
  FundOutlined,
};

export function resolveIcon(iconName) {
  const IconComponent = iconMap[iconName];
  return IconComponent ? <IconComponent /> : <BookOutlined />;
}
